import { createFileRoute, useNavigate } from '@tanstack/react-router'
import SlideWizard from '@/components/learning-paths/SlideWizard'
import { buildDefencesV2Chapter } from '@/learning-paths/incode/build-defences-v2/chapter'

export const Route = createFileRoute('/_auth/learning-journeys/digital-self-defence')({
  component: BuildDefencesV2Route,
})

function BuildDefencesV2Route() {
  const navigate = useNavigate()

  const handleExit = () => {
    navigate({
      to: '/learning-journeys/scam-fundamentals',
      search: { invitationcode: undefined, __clerk_ticket: undefined },
    })
  }

  return (
    <SlideWizard
      chapter={buildDefencesV2Chapter}
      onExit={handleExit}
      onComplete={handleExit}
    />
  )
}
